<!-- Modal Header -->
<div class="modal-header">
  <div class="header-content">
    <h3 class="modal-title">{{modalTitle}}</h3>
    <div class="header-icons">
      <i class="fa minimize-icon" 
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
         (click)="minimise = !minimise"></i>
      <i class="fa fa-times close-icon" (click)="cancel()"></i>
    </div>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [class.collapsed]="minimise">

  <!-- Loading Spinner -->
  @if (dataLoading) {
<div class="loading-container">
    <i class="fa fa-spinner fa-spin loading-icon"></i>
    <div class="loading-text">Loading Schedule M data...</div>
  </div>
}

  @if (!dataLoading) {
<div class="schedule-m-container">
  <!-- Entity Details -->
  <div class="entity-details">
    <h5>
      Entity Details : {{rowData.LE_NAME}} ({{rowData.LEID}}/{{rowData.CDR_NO}}/{{rowData.REPORTING_PERIOD}}) 
    </h5>
  </div>

  <!-- Instructions -->
  <div class="instructions">
    <h5>
      <i class="fa fa-info-circle"></i>
      Enter the totals for each type of transaction that occured during the annual accounting period between the FDE or FB and the persons listed in columns (b) through (f).
      All Amounts are in US Dollars translated from functional currency at the appropriate exchange rate for the FDE's or FB's tax year.
    </h5>
  </div>

  <!-- Currency Information -->
  <div class="currency-info">
    <h5> 
      The relevant functional currency and the exchange rate used throughout this schedule : {{rowData.HO_FUNCTIONAL_CURRENCY}} {{rowData.F5471_CURR}}
    </h5>
  </div>

  <!-- Section A Table -->
  <table class="table table-bordered schedule-table">
    <thead>
      <tr>
        <th rowspan="2" class="text-center line-header">5471 Line</th>
        <th rowspan="2" class="text-center transaction-header">Transaction of Foreign Corporation <br> (a)</th>
        <th rowspan="2" class="text-center column-header">U.S. person filing this return (System) <br> (b1)</th>
        <th rowspan="2" class="text-center column-header">U.S. person filing this return (Override)<br> (b)</th>
        <th rowspan="2" class="text-center column-header">Any domestic corporation or partnership controlled by U.S person filing this return(System) <br> (c1)</th>
        <th rowspan="2" class="text-center column-header">Any domestic corporation or partnership controlled by U.S. person filing this return(Override) <br> (c)</th>
        <th rowspan="2" class="text-center column-header">Any other foreign corporation or partnership controlled by U.S. person filing this return (System) <br> (d1)</th>
        <th rowspan="2" class="text-center column-header">Any other foreign corporation or partnership controlled by U.S. person filing this return (Override)<br> (d)</th>
        <th rowspan="2" class="text-center column-header">10% or more U.S shareholder of controlled foreign corporation (other than U.S. person filing this return) <br> (e)</th>
        <th rowspan="2" class="text-center column-header">10% or more U.S. shareholder of any corporation controlling the foreign corporation <br> (f)</th>
      </tr>
    </thead>
    <tbody>
      @for (line of getLinesByType('A'); track trackByLineNo($index, line)) {
<tr [ngStyle]="line.line_style">
        <td class="text-center line-number">{{ line.line_no }}</td>
        <td class="line-description">{{ line.line_Description }}</td>
        @for (column of line.column_description; track trackByIndex($index, column)) {
<td 
            class="text-right column-cell" 
            [ngStyle]="column.column_style">
          @if (column.is_Display) {
<div>
            @if (!column.is_editable) {
<div>{{ column.VALUE | number }}</div>
}
            @if (column.is_editable) {
<div>
              <input 
                type="text" 
                [(ngModel)]="column.VALUE"
                class="text-right form-control input-sm numText"
                (ngModelChange)="onFieldChange(column, line.line_no)"
                [disabled]="line.disabled || false">
            </div>
}
          </div>
}
        </td>
}
      </tr>
}
    </tbody>
  </table>

  <!-- Section B Table -->
  <table class="table table-bordered schedule-table">
    <thead>
      <tr>
        <th rowspan="2" class="text-center line-header">5471 Line</th>
        <th rowspan="2" class="text-center transaction-header">Transaction of Foreign Corporation <br> (a)</th>
        <th rowspan="2" class="text-center column-header">U.S. person filing this return (System) <br> (b1)</th>
        <th rowspan="2" class="text-center column-header">U.S. person filing this return (Override)<br> (b)</th>
        <th rowspan="2" class="text-center column-header">Any domestic corporation or partnership controlled by U.S person filing this return(System) <br> (c1)</th>
        <th rowspan="2" class="text-center column-header">Any domestic corporation or partnership controlled by U.S. person filing this return(Override) <br> (c)</th>
        <th rowspan="2" class="text-center column-header">Any other foreign corporation or partnership controlled by U.S. person filing this return (System) <br> (d1)</th>
        <th rowspan="2" class="text-center column-header">Any other foreign corporation or partnership controlled by U.S. person filing this return (Override)<br> (d)</th>
        <th rowspan="2" class="text-center column-header">10% or more U.S shareholder of controlled foreign corporation (other than U.S. person filing this return) <br> (e)</th>
        <th rowspan="2" class="text-center column-header">10% or more U.S. shareholder of any corporation controlling the foreign corporation <br> (f)</th>
      </tr>
    </thead>
    <tbody>
      @for (line of getLinesByType('B'); track trackByLineNo($index, line)) {
<tr [ngStyle]="line.line_style">
        <td class="text-center line-number">{{ line.line_no }}</td>
        <td class="line-description">{{ line.line_Description }}</td>
        @for (column of line.column_description; track trackByIndex($index, column)) {
<td 
            class="text-right column-cell" 
            [ngStyle]="column.column_style">
          @if (column.is_Display) {
<div>
            @if (!column.is_editable) {
<div>{{ column.VALUE | number }}</div>
}
            @if (column.is_editable) {
<div>
              <input 
                type="text" 
                [(ngModel)]="column.VALUE"
                class="text-right form-control input-sm numText"
                (ngModelChange)="onFieldChange(column, line.line_no)"
                [disabled]="line.disabled || false">
            </div>
}
          </div>
}
        </td>
}
      </tr>
}
    </tbody>
  </table>

  <!-- Section C Table -->
  <table class="table table-bordered schedule-table">
    <thead>
      <tr>
        <th rowspan="2" class="text-center line-header">5471 Line</th>
        <th rowspan="2" class="text-center transaction-header">Transaction of Foreign Corporation <br> (a)</th>
        <th rowspan="2" class="text-center column-header">U.S. person filing this return (System) <br> (b1)</th>
        <th rowspan="2" class="text-center column-header">U.S. person filing this return (Override)<br> (b)</th>
        <th rowspan="2" class="text-center column-header">Any domestic corporation or partnership controlled by U.S person filing this return(System) <br> (c1)</th>
        <th rowspan="2" class="text-center column-header">Any domestic corporation or partnership controlled by U.S. person filing this return(Override) <br> (c)</th>
        <th rowspan="2" class="text-center column-header">Any other foreign corporation or partnership controlled by U.S. person filing this return (System) <br> (d1)</th>
        <th rowspan="2" class="text-center column-header">Any other foreign corporation or partnership controlled by U.S. person filing this return (Override)<br> (d)</th>
        <th rowspan="2" class="text-center column-header">10% or more U.S shareholder of controlled foreign corporation (other than U.S. person filing this return) <br> (e)</th>
        <th rowspan="2" class="text-center column-header">10% or more U.S. shareholder of any corporation controlling the foreign corporation <br> (f)</th>
      </tr>
    </thead>
    <tbody>
      @for (line of getLinesByType('C'); track trackByLineNo($index, line)) {
<tr [ngStyle]="line.line_style">
        <td class="text-center line-number">{{ line.line_no }}</td>
        <td class="line-description">{{ line.line_Description }}</td>
        @for (column of line.column_description; track trackByIndex($index, column)) {
<td 
            class="text-right column-cell" 
            [ngStyle]="column.column_style">
          @if (column.is_Display) {
<div>
            @if (!column.is_editable) {
<div>{{ column.VALUE | number }}</div>
}
            @if (column.is_editable) {
<div>
              <input 
                type="text" 
                [(ngModel)]="column.VALUE"
                class="text-right form-control input-sm numText"
                (ngModelChange)="onFieldChange(column, line.line_no)">
            </div>
}
          </div>
}
        </td>
}
      </tr>
}
    </tbody>
  </table>

  <!-- Error Message -->
  @if (userMessage) {
<div class="alert alert-warning">
    {{ userMessage }}
  </div>
}

  </div>
} <!-- Close schedule-m-container -->
</div> <!-- Close modal-body -->

<!-- Footer Actions -->
<div class="modal-footer">
  <button 
    class="btn btn-info btn-sm" 
    type="button" 
    (click)="saveScheduleMData()"
    [disabled]="crudLoading">
    @if (crudLoading) {
<span>
      <i class="fa fa-spinner fa-pulse"></i>
    </span>
} 
    Save
  </button>
  <button 
    class="btn btn-warning btn-sm" 
    type="button" 
    (click)="cancel()">
    Cancel
  </button>
</div>
